import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAlertState } from 'selectors/alert.selector';
import { hideAlert } from 'actions/alert.actions';
import styled from 'styled-components';
import Alert from './Alert';
import styles from './ConnectedAlert.styles';

const Container = styled.div`
  ${styles}
`;

export function ConnectedAlert() {
  const dispatch = useDispatch();
  const { visible, message, type, autoclose } = useSelector(selectAlertState);
  const handleClose = () => {
    dispatch(hideAlert());
  };

  useEffect(() => {
    if (!autoclose) return;
    if (visible) {
      setTimeout(() => {
        dispatch(hideAlert());
      }, 5000);
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div style={{ position: 'absolute' }}>
      <Container>
        <Alert message={message} type={type} onClose={handleClose} />
      </Container>
    </div>
  );
}
